import { Link, Typography, useTheme } from "@mui/material";
import useInterfaceConfig from "@hooks/useInterfaceConfigV2";

export const TerminosCondiciones = () => {
  const theme = useTheme();
  const interfaceConfig = useInterfaceConfig();

  return (
    <Typography textAlign={"center"} color={theme?.palette?.primary?.dark}>
      Al continuar estás aceptando nuestros{" "}
      <Link href={interfaceConfig?.url_terms_and_conditions} target="_blank">
        <Typography component={"span"}>términos y condiciones</Typography>
      </Link>{" "}
      y{" "}
      <Link href={interfaceConfig?.url_privacy_notice} target="_blank">
        <Typography component={"span"}>políticas de privacidad</Typography>
      </Link>
    </Typography>
  );
};
